import { render, staticRenderFns } from "./ChangeAiAnswerEffect.vue?vue&type=template&id=e08074c2&scoped=true&"
import script from "./ChangeAiAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeAiAnswerEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08074c2",
  null
  
)

export default component.exports